import React from 'react';
import HeaderLayout from '../Header/HeaderLayout'
import styles from './MainLayout.module.scss';
// @ts-ignore
import classNames from 'classnames';

export default ({children}: any) => {
  return (
    <>
      <div className={styles.main}>
        <HeaderLayout />
        
        <div className={classNames(
            styles['main__body'],
        )}>
          {children}
        </div>
      </div>
    </>
  )
}